'use client';

import {useMeQuery} from '@hooks';
import {UserService} from '@services/user/user.service';
import {getIsServer} from '@utils/getIsServer';
import {usePathname} from 'next/navigation';
import {FC, useEffect} from 'react';

const TimezoneUpdate: FC = () => {
    // reevaluate on path change

    usePathname();
    const {
        query: {data: user},
    } = useMeQuery();
    // this function is very fast, we do not need to worry about performance
    const timezone = getIsServer()
        ? null
        : Intl.DateTimeFormat().resolvedOptions().timeZone;

    useEffect(() => {
        if (!user || !timezone || user.timezone === timezone) {
            return;
        }

        console.log(
            `Detected change in timezone, update user preference to: ${timezone}`,
        );

        // Update the timezone if it has changed
        //  The user is also invalidated in this method afterward.
        // Was thinking long if I should use a mutation, but decided not to,
        //  I didn't find a single reason why a mutation would be better here
        UserService.updateTimezone(timezone);
    }, [user?.id, timezone]);

    return null;
};

export default TimezoneUpdate;
